module.exports = __webpack_public_path__ + "media/images/extendyourteam-4422f45359d43816834847ac1c1a90c2.png";